export default __webpack_public_path__ + "resources/icons/n420-7cf1.webp";